import { http } from '@/utils/http';
import qs from 'qs';

// 新闻
export function NewsList(voteName: string) {
  return http.get('/vote/' + voteName + '/controller.php?enews=news-list');
}

// 全国和重庆数值
export function Country(voteName: string) {
  return http.get('/vote/' + voteName + '/controller.php?enews=country');
}

// 省份
export function Province(voteName: string) {
  return http.get('/vote/' + voteName + '/controller.php?enews=province');
}

// area 区县
export function Area(voteName: string) {
  return http.get('/vote/' + voteName + '/controller.php?enews=area');
}

// 折线图数据

export function CountryList(voteName: string) {
  return http.get('/vote/' + voteName + '/controller.php?enews=country-list');
}
